import {createContext, FC, ReactNode, useState} from 'react';

export interface ObserverContextProps {
  currentSection: string;
  handleCurrentSection: (value: string) => void;
}

interface ObserverProviderProps {
  children: ReactNode;
}

const ObserverContext = createContext<ObserverContextProps>(
  {} as ObserverContextProps,
);

export const ObserverContextProvider: FC<ObserverProviderProps> = ({
  children,
}) => {
  const [currentSection, setCurrentSection] = useState<string>('');

  function handleCurrentSection(value: string) {
    setCurrentSection(value);
  }

  return (
    <ObserverContext.Provider
      value={{
        currentSection,
        handleCurrentSection,
      }}>
      {children}
    </ObserverContext.Provider>
  );
};

export default ObserverContext;
